import React, { Fragment } from 'react';
import Styles from './index.less';
import ARROW_ICON from '@tencent/docs-design-resources/icon/desktop/svg/arrowhead_down_12.svg';
import classNames from 'classnames';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';

export interface IPanelCard {
    name?: string;
    cardList: Array<{
        element: React.ReactElement;
        id: string;
    }>;
}

export interface ISelectablePanelProps {
    cardStyle?: React.CSSProperties;
    defaultShowIndex?: number;
    childrenElements: Array<IPanelCard>;
    colNumber: number;
    showArrow: boolean;
    expandHeight?: number | 'auto';
    style?: React.CSSProperties;
    selectedId?: string;
    appendElement?: React.ReactNode;
    collapsed?: boolean;
    wrapperStyle?: React.CSSProperties;
    backgroundStyle?: React.CSSProperties;
    onCustomArrowClick?(props?: any);
}

export interface ISelectablePanelState {
    collapsed: boolean;
    isHover: boolean;
}

const DEFAULT_COLLAPSED_HEIGHT = 48;
const DEFAULT_EXPAND_HEIGHT = 200;

/**
 * 工具栏选择面板组件
 */
export default class SelectablePanel extends React.PureComponent<ISelectablePanelProps, ISelectablePanelState> {
    public constructor(props: ISelectablePanelProps) {
        super(props);
        this.state = {
            collapsed: props.collapsed ?? true,
            isHover: false,
        };
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.hide);
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.hide);
    }

    // eslint-disable-next-line complexity
    public render() {
        const { childrenElements, showArrow, colNumber, style, selectedId,
            appendElement, wrapperStyle, backgroundStyle } = this.props;
        const singleLineElement: Array<{ element: React.ReactElement, id: string }> = [];

        childrenElements.forEach((card) => {
            const { cardList } = card;
            cardList.forEach((element) => {
                singleLineElement.push(element);
            });
        });

        const { collapsed } = this.state;
        const defaultShowIndex = this.props.defaultShowIndex || 0;
        return <div
            className={Styles['selectable-panel-wrapper']}
            style={wrapperStyle}
        >
            <div
                onMouseDown={(e) => {
                    e.nativeEvent.stopImmediatePropagation();
                    e.stopPropagation();
                    e.preventDefault();
                }}
                onWheel={(e) => {
                    e.nativeEvent.stopImmediatePropagation();
                    e.stopPropagation();
                }}
                className={Styles['selectable-panel-background']}  style={{
                    height: collapsed ? DEFAULT_COLLAPSED_HEIGHT : this.props.expandHeight || DEFAULT_EXPAND_HEIGHT,
                    boxShadow: collapsed ? undefined : '0 5px 12px 4px rgba(0, 0, 0, 0.08)',
                    borderRadius: (!collapsed && appendElement) ? '4px 4px 0 0' : undefined,
                    ...backgroundStyle,
                }} >
                {
                    collapsed
                        ? <div
                            className={Styles['selectable-panel-container']} style={{
                                ...style,
                                flexWrap: 'nowrap',
                            }} >
                            {
                                singleLineElement.slice(
                                    defaultShowIndex,
                                    defaultShowIndex + colNumber,
                                ).map((child, index) => <div
                                    key={index}
                                    className={classNames({
                                        [Styles['selectable-card-container']]: true,
                                    })}
                                >
                                    { child.element }
                                    <div className={
                                        classNames({
                                            [Styles['selected-container']]: true,
                                            [Styles.active]: selectedId === child.id,
                                        })
                                    }
                                    style={{
                                        ...this.props.cardStyle,
                                    }}
                                    />
                                </div>)
                            }
                        </div> : <div className={Styles['multi-row-container']}>
                            {
                                childrenElements.map((card, index) => {
                                    const { cardList, name } = card;
                                    return <div
                                        className={Styles['multi-theme-wrapper']}
                                        key={name}
                                        style={{
                                            marginBottom: index === childrenElements.length - 1 ? 0 : undefined,
                                            marginTop: index === 0  && name ? undefined : 0,
                                        }}
                                    >
                                        { name ? <div className={Styles['multi-line-title-wrapper']}>
                                            <div className={Styles['multi-line-title']}>
                                                { name }
                                            </div>
                                        </div> : undefined }
                                        <div key={name} className={Styles['selectable-panel-container']} style={{
                                            ...style,
                                            height: 'max-content',
                                            width: '100%',
                                            flexWrap: 'wrap',
                                        }} >
                                            {
                                                cardList.map((child, index) => <div
                                                    key={index}
                                                    className={classNames({
                                                        [Styles['selectable-card-container']]: true,
                                                    })}
                                                >
                                                    { child.element }
                                                    <div className={
                                                        classNames({
                                                            [Styles['selected-container']]: true,
                                                            [Styles.active]: selectedId === child.id,
                                                        })
                                                    }
                                                    style={{
                                                        ...this.props.cardStyle,
                                                    }}
                                                    />
                                                </div>)
                                            }
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                }
                {
                    showArrow && <div
                        onClick={this.onArrowClick}
                        className={classNames({
                            [Styles['collapsed-arrow-wrapper']]: true,
                        })}>
                        <img className={classNames({
                            [Styles['collapsed-arrow']]: true,
                        })} src={ARROW_ICON}
                        />
                    </div>
                }
            </div>
            {
                (!collapsed && appendElement) && appendElement
            }
        </div>;
    }

    private onArrowClick = () => {
        if (this.props.onCustomArrowClick) {
            this.props.onCustomArrowClick();
            return;
        }

        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    private hide = () => {
        if (!this.state.collapsed) {
            this.setState({
                collapsed: true,
            });
        }
    };
}
